import React from "react";
import { Route, Routes } from "react-router-dom";
import { Box } from "@mui/material";
import CategoryForm from "../pages/categories/CreateCategory";
import UploadHomeBanner from "../pages/Home banners/UploadHomeBanner";
import HomeBannersList from "../pages/Home banners/HomeBannersList";
import GetAdminCategories from "../pages/categories/GetAdminCategories";
import CreateProductForm from "../pages/products/CreateProductForm";
import AdminProductsList from "../pages/products/AdminProductsList";
import CreateProductTab from "../pages/ProductTabs/CreateProductTab";
import GetProductTabs from "../pages/ProductTabs/GetProductTabs";
import CreateCmsContent from "../pages/CmsContent/CreateCmsContent";
import CmsContentList from "../pages/CmsContent/CmsContentList";
import CreateStore from "../pages/Store/CreateStore";
import GetAdminStores from "../pages/Store/GetAdminStores";
import GetAdminTimeslots from "../pages/Timeslot/GetAdminTimeslots";
import CreateTimeslot from "../pages/Timeslot/CreateTimeslot";
import GetAllUsers from "../pages/Users/GetAllUsers";
import UserDetails from "../pages/Users/UserDetails";
import StoreCounterForm from "../pages/StoreCounter/StoreCounterForm";
import StoreCounterList from "../pages/StoreCounter/StoreCounterList";
import LoginPage from "../pages/Login/LoginPage";
import DashboardPage from "../pages/Dashboard/DashboardPage";
import GetAdminCoupons from "../pages/Coupon/GetAdminCoupons";
import CreateCoupon from "../pages/Coupon/CreateCoupon";
import AllBookings from "../pages/Bookings/AllBookings";
import BookingDetails from "../pages/Bookings/BookingDetails";
import ExtraFeeManagement from "../pages/ExtraFee/ExtraFeeManagement";
import EditExtraFee from "../pages/ExtraFee/EditExtraFee";




const PageRoutes = () => {
  return (
    <Box>
      <Routes>


        {/* Categories */}
        <Route path="/getadmincategory" element={<GetAdminCategories />} />
        <Route path="/getadmincategory/add" element={<CategoryForm />} />
        <Route path="/getadmincategory/edit/:id" element={<CategoryForm />} />


        {/* Home screen banner */}
        <Route path="/UploadHomeBanner" element={<UploadHomeBanner />} />
        <Route path="/homebanners/edit/:id" element={<UploadHomeBanner />} />    
        <Route path="/HomeBannersList" element={<HomeBannersList />} />
        <Route path="/homebanners/add" element={<UploadHomeBanner />} />


        {/* Products */}
        {/* <Route path="/CreateProductForm" element={<CreateProductForm />} /> */}
        <Route path="/adminproducts/add" element={<CreateProductForm />} />
        <Route path="/AdminProductsList" element={<AdminProductsList />} />
        <Route path="/adminproducts/edit/:id" element={<CreateProductForm />} />
        <Route path="/AdminProductsList/:categoryId?" element={<AdminProductsList />} />

        {/* CreateProductTab */}
        <Route path="/getproducttabs/add" element={<CreateProductTab />} />
        <Route path="/getproducttabs/edit/:id" element={<CreateProductTab />} />
        <Route path="/GetProductTabs" element={<GetProductTabs />} />

        <Route path="/adminproducts" element={<AdminProductsList />} />
        <Route path="/getproducttabs/:productId" element={<GetProductTabs />} />


        {/*CmsContent */}
        <Route path="/cmscontent/add" element={<CreateCmsContent />} />
        <Route path="/cmscontent/edit/:type" element={<CreateCmsContent />} />
        <Route path="/CmsContentList" element={<CmsContentList />} />


        {/* Store */}
        <Route path="/getadminstores" element={<GetAdminStores />} />
        <Route path="/getadminstores/add" element={<CreateStore />} />
        <Route path="/editstore/:id" element={<CreateStore />} />


        {/* Time slots */}
        <Route path="/getadmintimeslot" element={<GetAdminTimeslots />} />
        <Route path="/getadmintimeslot/add" element={<CreateTimeslot />} />
        <Route path="/getadmintimeslot/edit" element={<CreateTimeslot />} />
        <Route path="/getadmintimeslot/edit/:id" element={<CreateTimeslot />} />

        {/* Users */}
        {/* <Route path="/Users-form" element={<GetAllUsers />} /> */}
        <Route path="/users" element={<GetAllUsers />} />
        <Route path="/users/:id" element={<UserDetails />} />

        {/* StoreCounter */}
        <Route path="/storecounter/add" element={<StoreCounterForm />} />
        <Route path="/storecounter/edit" element={<StoreCounterForm />} />
        <Route path="/storecounter/list" element={<StoreCounterList />} />
        {/* <Route path="/storecounter/edit" element={<StoreCounterList />} /> */}

        {/* Delhiver price */}
        <Route path="/extra-fees" element={<ExtraFeeManagement />} />
        <Route path="/extra-fees/edit/:id" element={<EditExtraFee />} />

        {/* DashBoard */}
        <Route path="/" element={<DashboardPage />} />


        {/* Coupons */}
        <Route path="/getadmincoupons" element={<GetAdminCoupons />} />
        <Route path="/getadmincoupons/add" element={<CreateCoupon />} />
        <Route path="/editcoupon/:id" element={<CreateCoupon />} />


        {/* Bookings */}
        <Route path="/bookings" element={<AllBookings />} />
        <Route path="/bookings/:id" element={<BookingDetails />} />

      </Routes>
    </Box>
  );
};

export default PageRoutes;
